import {
    Container,
    Text,
    Stack,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Card,
    CardBody,
    SimpleGrid,
    Image,
    Heading,
    Center,
    Select
} from "@chakra-ui/react"
import { NavBar } from "../components/navbar"
import { useState } from "react"

export const Students = () => {
    const [filter, setFilter] = useState("");

    const phdStudents = [
        {
            id: 1,
            name: "Japheth Mumo Kimeu",
            start_year: 2025,
            research_areas: [
                "Human-Computer Interaction",
                "Mobile Systems",
                "Artificial Intelligence",
                "Persuasive Technology",
                "and Digital Health"
            ],
            other_research_area: null,
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/phd/japheth_kimeu.png"
        },
        {
            id: 2,
            name: "Josteve Adekanbi",
            start_year: 2025,
            research_areas: [
                "Human-Computer Interaction",
                "Artificial Intelligence",
                "Adaptive Computing",
                "and Persuasive Technology"
            ],
            other_research_area: "with an emphasis on enhancing Health and Wellness",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/phd/josteve_adekanbi.png"
        }
    ]

    const mcsStudents = [
        {
            id: "mcs0001",
            name: "Gladwin Irudayaraj",
            start_year: 2025,
            research_areas: [
                "Human-Computer Interaction",
                "Artificial Intelligence",
                "Persuasive Technology",
                "User-Adaptive Systems",
                "and Privacy & Security"
            ],
            other_research_area: null,
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/mcs/gladwin.jpeg"
        },
        {
            id: "mcs0002",
            name: "Aakash Yadav",
            start_year: 2024,
            research_areas: [
                "Persuasive Technology", "User-Adaptive Systems", "Digital Health", "Edge Computing", "Federated Learning", "and User Privacy"
            ],
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/mcs/aakash.jpeg"
        },
    ]

    const ras = [
    ]

    const interns = [
        {
            id: "ri001",
            name: "Anand Lo",
            start_year: 2025,
            research_project: "Multisensor adaptive intelligent system for stress and anxiety management",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/ra/anand.jpeg"
        },
        {
            id: "ri002",
            name: "Pranav Srinivasan",
            start_year: 2025,
            research_project: "AI-Driven Behaviour Change Interventions to Address Vaccination Uptake and Acceptance Barriers",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/ra/pranav.jpeg"
        },
        {
            id: 20,
            name: "Tushant Kaura",
            start_year: 2025,
            research_project: "AI-driven and gaze-based persuasive technology for dietary management",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/tushant.jpeg"
        },
        {
            id: 22,
            name: "Param Kataria",
            start_year: 2025,
            research_project: "AI-driven and augmented reality-based persuasive technology for social good",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/param.jpeg"
        },
        {
            id: 21,
            name: "Edward Addo Jr.",
            start_year: 2025,
            research_project: "AI-driven and gaze-based persuasive technology for dietary management",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/edward.jpeg"
        },
        {
            id: 23,
            name: "Jai Sachdeva",
            start_year: 2025,
            research_project: "(i) AI-driven personalized interventions for breast and colorectal cancer survivorship; (ii) AI-driven and augmented reality-based persuasive technology for social good",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/jai.jpeg"
        },
        {
            id: 24,
            name: "Yugam Yugam",
            start_year: 2025,
            research_project: "AI-driven and augmented reality-based persuasive technology for social good",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/yugam.jpeg"
        },
        {
            id: 25,
            name: "Abolanle Ogundairo",
            start_year: 2025,
            research_project: "LLM-driven persuasive technology for health and wellness in underrepresented populations",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/bolanle.jpeg"
        },
        {
            id: 26,
            name: "John Ezembu",
            start_year: 2025,
            research_project: "LLM-driven persuasive technology for health and wellness in underrepresented populations",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/interns/john.jpg"
        },
    ]

    const macsStudents = [
    ]

    const macsStudentsPast = [
        {
            id: 11,
            name: "Harsh Maisuri",
            start_year: 2024,
            grad_year: "Winter 2025",
            research_project: "SerenCoach 2.0: A multimodal AI-driven mobile-based persuasive technology that assesses anxiety and depression risk through facial expressions, text analysis, voice analysis, and keystroke dynamics, and then provides behaviour change interventions based on the predicted risk level.",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/harsh.jpg"
        },
        {
            id: 12,
            name: "Raj Kamlesh Patel",
            start_year: 2024,
            grad_year: "Winter 2025",
            research_project: "Design and develop an AI-driven collaborative fitness application that promote group-based physical activity, such as walking, running, and cycling. By leveraging AI-powered user recommendations and real-time tracking, the application enhances social interaction and motivation for achieving fitness goals.",
            other_research_area: "with an emphasis on enhancing Health and Wellness",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/raj_patel.jpeg"
        },
        {
            id: 13,
            name: "Anjali Rachel Benjamin",
            start_year: 2024,
            grad_year: "Winter 2025",
            research_project: "ReflectAI (Phase 1): Develop a multimodal AI system for real-time emotion detection from text, voice, and image/video, and deploy as an application programming interface (API).",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/anjali_2.jpeg"
        },
        {
            id: 14,
            name: "Judith Kurian",
            start_year: 2023,
            grad_year: "Winter 2025",
            research_project: "ReflectAI (Phase 2): Design and develop an AI-powered digital emotion/mood journal for promoting mental well-being. The digital journal integrates with the multimodal AI system from phase 1 to deliver emotion-adaptive behaviour change interventions.",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/judith.jpg"
        },
        {
            id: 15,
            name: "Md Samshad Rahman",
            start_year: 2023,
            grad_year: "Winter 2025",
            research_project: "MindfulMenu: An AI-driven personalized and persuasive mobile application for promoting mindful eating through real-time behavioural analysis and adaptive feedback",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/samshad.jpg"
        },
        {
            id: 16,
            name: "Sivasubramanian Venkatasubramanian",
            start_year: 2024,
            grad_year: "Winter 2025",
            research_project: "An AI-driven persuasive navigation system for promoting safe travels",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/siva.jpeg"
        },
        {
            id: 1,
            name: "Dharmil Nareshkumar Shah",
            start_year: 2023,
            grad_year: "Fall 2024",
            research_project: "CalmMe (Phase 1): Develop and deploy a backend system for real-time stress detection based on heart rate variability (HRV) using deep learning and FastAPI.",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/dharmil.jpg"
        },
        {
            id: 2,
            name: "Aman Desai",
            start_year: 2023,
            grad_year: "Fall 2024",
            research_project: "CalmMe (Phase 2): Design and develop an AI-driven persuasive mobile application for stress management while leveraging Apple Watch sensor (for heart rate variability tracking) and the deep learning model from phase 1 for real-time stress detection.",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/aman.jpg"
        },
        {
            id: 3,
            name: "Vishesh Patel",
            start_year: 2023,
            grad_year: "Fall 2024",
            research_project: "SerenCoach: An intelligent mobile application that assesses anxiety and depression risk levels using large language model (LLM) and then delivers evidence-based therapeutic interventions to individual users based on their risk level.",
            photo: "https://web.cs.dal.ca/~oyebode/project/website/students/macs/vishesh.png"
        }
    ]

    return (
        <>
            <NavBar selectedId={5} />
            <Container maxW={"6xl"} pb={20} mt={{ base: 8, md: 8 }}>
                <Stack direction={"row"} alignItems={"center"} justify={"space-between"}>
                    <Text ml={{ md: "39%" }} textAlign={"center"} fontSize={{ base: "2xl", md: "3xl" }} fontWeight={600}>{!filter ? "Current" : filter} Students</Text>
                    <Select placeholder='All' w={"95px"} size={"sm"} rounded={10} onChange={(e) => setFilter(e.target.value)}>
                        <option value='Current'>Current</option>
                        <option value='Past'>Alumni</option>
                    </Select>
                </Stack>

                {/* <Stack px={{ base: 3, md: 0 }} as="ul" spacing={4} pt={10} fontSize={"lg"}> */}
                <Accordion defaultIndex={[0, 1, 2, 3]} allowMultiple pt={8} display={filter === "Past" ? "none" : "block"}>
                    <AccordionItem>
                        <h2>
                            <AccordionButton bg={"gray.100"}>
                                <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                    Doctor of Philosophy (PhD)
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <Center>
                            <AccordionPanel pb={8}>
                                <SimpleGrid columns={{ base: 1, md: phdStudents.length >= 3 ? 3 : phdStudents.length }} columnGap={5} rowGap={5}>
                                    {
                                        phdStudents.map(v =>
                                            <Card maxW='sm' key={v.id}>
                                                <CardBody>
                                                    <Image
                                                        src={v.photo}
                                                        borderRadius='lg'
                                                        h={"300px"}
                                                    />
                                                    <Stack mt='4' spacing='3'>
                                                        <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                        <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research interests</Text>: &nbsp;
                                                            {v.research_areas.join(", ") + (v.other_research_area ? ", " + v.other_research_area : "")}
                                                        </Text>
                                                        <Text fontSize={"sm"}>
                                                            <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                        </Text>
                                                    </Stack>
                                                </CardBody>
                                            </Card>
                                        )
                                    }
                                </SimpleGrid>
                            </AccordionPanel>
                        </Center>
                    </AccordionItem>
                    {
                        mcsStudents.length > 0 && <AccordionItem>
                            <h2>
                                <AccordionButton bg={"blue.50"}>
                                    <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                        Master of Computer Science (MCS)
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <Center>
                                <AccordionPanel pb={8}>
                                    <SimpleGrid columns={{ base: 1, md: mcsStudents.length >= 3 ? 3 : mcsStudents.length }} columnGap={5} rowGap={5}>
                                        {
                                            mcsStudents.map(v =>
                                                <Card maxW='sm' key={v.id}>
                                                    <CardBody>
                                                        <Image
                                                            src={v.photo}
                                                            borderRadius='lg'
                                                            h={"300px"}
                                                            w={"100%"}
                                                            fit={"contain"}
                                                        />
                                                        <Stack mt='4' spacing='3'>
                                                            <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                            <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research interests</Text>: &nbsp;
                                                                {v.research_areas.join(", ") + (v.other_research_area ? ", " + v.other_research_area : "")}
                                                            </Text>
                                                            <Text fontSize={"sm"}>
                                                                <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                            </Text>
                                                        </Stack>
                                                    </CardBody>
                                                </Card>
                                            )
                                        }
                                    </SimpleGrid>
                                </AccordionPanel>
                            </Center>
                        </AccordionItem>
                    }
                    {
                        ras.length > 0 && <AccordionItem>
                            <h2>
                                <AccordionButton bg={"purple.50"}>
                                    <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                        Research Assistants
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <Center>
                                <AccordionPanel pb={8}>
                                    <SimpleGrid columns={{ base: 1, md: ras.length >= 3 ? 3 : ras.length }} columnGap={5} rowGap={5}>
                                        {
                                            ras.map(v =>
                                                <Card maxW='sm' key={v.id}>
                                                    <CardBody>
                                                        <Image
                                                            src={v.photo}
                                                            borderRadius='lg'
                                                            h={"300px"}
                                                            w={"100%"}
                                                            fit={"contain"}
                                                        />
                                                        <Stack mt='4' spacing='3'>
                                                            <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                            <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research project</Text>: &nbsp;
                                                                {v.research_project}
                                                            </Text>
                                                            <Text fontSize={"sm"}>
                                                                <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                            </Text>
                                                        </Stack>
                                                    </CardBody>
                                                </Card>
                                            )
                                        }
                                    </SimpleGrid>
                                </AccordionPanel>
                            </Center>
                        </AccordionItem>
                    }
                    {
                        interns.length > 0 && <AccordionItem>
                            <h2>
                                <AccordionButton bg={"pink.50"}>
                                    <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                        Research Interns
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <Center>
                                <AccordionPanel pb={8}>
                                    <SimpleGrid columns={{ base: 1, md: interns.length >= 3 ? 3 : interns.length }} columnGap={5} rowGap={5}>
                                        {
                                            interns.map(v =>
                                                <Card maxW='sm' key={v.id}>
                                                    <CardBody>
                                                        <Image
                                                            src={v.photo}
                                                            borderRadius='lg'
                                                            h={"300px"}
                                                            w={"100%"}
                                                            fit={"contain"}
                                                        />
                                                        <Stack mt='4' spacing='3'>
                                                            <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                            <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research project</Text>: &nbsp;
                                                                {v.research_project}
                                                            </Text>
                                                            <Text fontSize={"sm"}>
                                                                <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                            </Text>
                                                        </Stack>
                                                    </CardBody>
                                                </Card>
                                            )
                                        }
                                    </SimpleGrid>
                                </AccordionPanel>
                            </Center>
                        </AccordionItem>
                    }
                    {
                        macsStudents.length > 0 && <AccordionItem>
                            <h2>
                                <AccordionButton bg={"blue.50"}>
                                    <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                        Master of Applied Computer Science (MACS)
                                    </Box>
                                    <AccordionIcon />
                                </AccordionButton>
                            </h2>
                            <Center>
                                <AccordionPanel pb={8}>
                                    <SimpleGrid columns={{ base: 1, md: macsStudents.length >= 3 ? 3 : macsStudents.length }} columnGap={5} rowGap={5}>
                                        {
                                            macsStudents.map(v =>
                                                <Card maxW='sm' key={v.id}>
                                                    <CardBody>
                                                        <Image
                                                            src={v.photo}
                                                            borderRadius='lg'
                                                            h={"300px"}
                                                            w={"100%"}
                                                            fit={"contain"}
                                                        />
                                                        <Stack mt='4' spacing='3'>
                                                            <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                            <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research project</Text>: &nbsp;
                                                                {v.research_project}
                                                            </Text>
                                                            <Text fontSize={"sm"}>
                                                                <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                            </Text>
                                                        </Stack>
                                                    </CardBody>
                                                </Card>
                                            )
                                        }
                                    </SimpleGrid>
                                </AccordionPanel>
                            </Center>
                        </AccordionItem>
                    }
                </Accordion>

                <Text display={filter === "Past" || filter === "Current" ? "none" : "block"} textAlign={"center"} fontSize={{ base: "2xl", md: "3xl" }} fontWeight={600} pt={8}>Past Students</Text>
                <Accordion defaultIndex={[0, 1]} allowMultiple pt={6} display={filter === "Current" ? "none" : "block"}>
                    <AccordionItem>
                        <h2>
                            <AccordionButton bg={"blue.50"}>
                                <Box as='span' flex='1' textAlign='center' fontSize={'lg'} fontWeight={600}>
                                    Master of Applied Computer Science (MACS)
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <Center>
                            <AccordionPanel pb={8}>
                                <SimpleGrid columns={{ base: 1, md: macsStudentsPast.length >= 3 ? 3 : macsStudentsPast.length }} columnGap={5} rowGap={5}>
                                    {
                                        macsStudentsPast.map(v =>
                                            <Card maxW='sm' key={v.id}>
                                                <CardBody>
                                                    <Image
                                                        src={v.photo}
                                                        borderRadius='lg'
                                                        h={"300px"}
                                                        w={"100%"}
                                                        fit={"contain"}
                                                    />
                                                    <Stack mt='4' spacing='3'>
                                                        <Heading size='md' alignSelf={"center"}>{v.name}</Heading>
                                                        <Text fontSize={"sm"}><Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Research project</Text>: &nbsp;
                                                            {v.research_project}
                                                        </Text>
                                                        <Text fontSize={"sm"}>
                                                            <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Start year</Text>:&nbsp;{v.start_year}
                                                        </Text>
                                                        <Text fontSize={"sm"}>
                                                            <Text as={"span"} fontWeight={600} color={"blackAlpha.700"}>Graduation term</Text>:&nbsp;{v.grad_year}
                                                        </Text>
                                                    </Stack>
                                                </CardBody>
                                            </Card>
                                        )
                                    }
                                </SimpleGrid>
                            </AccordionPanel>
                        </Center>
                    </AccordionItem>
                </Accordion>
            </Container>
        </>
    )
}